import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import containers from './containers'
import cleanings from './cleanings'
import companies from './companies'
import cargos from './cargos'
import vehicles from './vehicles'
import dashboard from './dashboard'
import users from "./users";
import {vm} from '@/main'

Vue.use(Vuex)

var baseUrl = process.env.VUE_APP_BASE_URL


export default new Vuex.Store({
    modules: {
        auth,
        containers,
        cargos,
        companies,
        cleanings,
        vehicles,
        dashboard,
        users
    },

    state: {
        search:'',
        errorStatus: false,
        errorMessage: null,
        snackbar: false,
        snackbarColor: '',
        snackbarTimeout: 2000,
        snackbarText: '',
    },

    mutations: {
        setSearch(state, payload){
            state.search = payload
        },
        setErrorMessage(state, message){
            state.errorStatus = true
            state.errorMessage = message
        },
        resetErrors(state){
            state.errorStatus = false
            state.errorMessage = null
        },
        setSnackbar(state, payload){
            state.snackbar = true
            state.snackbarColor = payload.color
            state.snackbarText = payload.text
        },
        clearSnackbar(state){
            state.snackbar = false
        }
    },

    actions: {
        resetSearch(context){
            const defaultSearch = ''
            context.commit('setSearch', defaultSearch)
        },
        changeSearch(context, payload){
            context.commit('setSearch', payload)
        },
        resetErrors({commit}){
            commit('resetErrors')
        },
        setSnackbar({commit}, payload){
            commit('setSnackbar', payload)
            setTimeout(() => { commit('clearSnackbar') }, 5000);
        },
        clearSnackbar({commit}){
            commit('clearSnackbar')
        }

    },
    getters: {
        search(state){
            return state.search
        },
        errorStatus(state){
            return state.errorStatus
        },
        errorMessage(state){
            return state.errorMessage
        },
        snackbar(state){
            return state.snackbar
        },
        snackbarColor(state){
            return state.snackbarColor
        },
        snackbarTimeout(state){
            return state.snackbarTimeout
        },
        snackbarText(state){
            return state.snackbarText
        },
    }
})
